import { guideTips } from "@/mocks/home";

export default function Guide() {
  return (
    <section id="guide" className="bg-background-50 border-t border-background-200">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
          <div className="lg:col-span-4">
            <span className="text-xs md:text-sm font-medium tracking-wide text-accent-700">
              观影提示
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-semibold text-foreground-950 leading-snug">
              浏览完整版内容前，值得留意的几点
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
              信息整理的价值在于帮你更快做判断，而不是替你做决定。下面四点能让浏览过程更省心，也更安全。
            </p>
            <div className="mt-6 rounded-lg bg-primary-50 border border-primary-200 p-4">
              <div className="flex items-start gap-3">
                <span className="w-8 h-8 shrink-0 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-copyright-line"></i>
                </span>
                <p className="text-xs md:text-sm leading-relaxed text-primary-900">
                  影视作品受版权保护，请通过获得授权的正规渠道观看。本站不提供文件、不代替版权方发布内容。
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-2 gap-4 md:gap-5">
            {guideTips.map((tip) => (
              <article
                key={tip.id}
                className="rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
              >
                <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                  <i className={`${tip.icon} text-xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-base md:text-lg font-semibold text-foreground-950">
                  {tip.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{tip.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}